
<template>

	<div class="content">
		<!-- 如果需要页头 -->
	<!-- 	<el-page-header @back="goBack" content="红包页面">
	</el-page-header> -->
	
	<el-tabs v-model="activeName" @tab-click="handleClick" stretch="stretch" class="tabs-hongbao" >
		<el-tab-pane label="红包" name="first">

			<div class="wraper_list" v-for="(n,nindex) in items">
				<div class="wraper_info" >
					<img src="/static/images/photo.png" alt="">
					<h3>{{n.company}}</h3>
				</div>
				<div v-if="n.brandFold?index:index<2" class="card_list" v-for="(item, index ) in n.detailList" :ref="item.id" >
					<div class="card_item">
						<div  class="card_item_price">
							<h3>￥{{item.price}}</h3>
						</div>
						<div class="card_item_condition">
							<h4>满{{item.condition}}可用</h4>
							<p>有效期至{{item.date}}</p>
						</div>
						<div class="card_item_use">
							<el-button size="small" round class='redBtn'>去使用</el-button>
						</div>

					</div>

				</div>
	<!-- 传入Nindex，判定当前是合并还是打开的状态. -->

				<div v-if="n.detailList.length>2" @click="changeFoldState(nindex)" class="floldState" >
					<span>{{n.brandFold?'收起':'展开'}}</span><img :class="[n.brandFold?'up':'down']" src="/static/images/down.png" alt="">

				</div>

			</div>


		



		</el-tab-pane>
		<el-tab-pane label="卡券" name="second">


			<div class="wraper_list" v-for="(n,nindex) in items">
				<div class="wraper_info" >
					<img src="/static/images/photo.png" alt="">
					<h3>{{n.company}}</h3>
				</div>
				<div v-if="n.brandFold?index:index<2" class="card_list" v-for="(item, index ) in n.detailList" :ref="item.id" >
					<div class="card_item">
						<div  class="card_item_price">
							<h3>￥{{item.price}}</h3>
						</div>
						<div class="card_item_condition">
							<h4>满{{item.condition}}可用</h4>
							<p>有效期至{{item.date}}</p>
						</div>
						<div class="card_item_use">
							<el-button size="small" round class='redBtn'>去使用</el-button>
						</div>

					</div>

				</div>
	<!-- 传入Nindex，判定当前是合并还是打开的状态. -->

				<div v-if="n.detailList.length>2" @click="changeFoldState(nindex)" class="floldState" >
					<span>{{n.brandFold?'收起':'展开'}}</span><img :class="[n.brandFold?'up':'down']" src="/static/images/down.png" alt="">

				</div>

			</div>



		</el-tab-pane>

	</el-tabs>













	<navBar :idx="3"></navBar>
</div>


</template>




<script>
	import navBar from '@/components/navBar';

	export default {
		name:'hongbao',
		components:{
			navBar,
		},	
		data(){
			return{
				activeName: 'first',
				stretch:true,
				
			items:{"girl":{ 
                         "company":"abc", 
                         "brandFold":false,
                         "detailList": [
                         {         
                              "id":"1",
                              "price": "Google",
                              "condition":"200",
                              "date": "2020.09.20"
                         },
                         {    
                              "id":"2",
                              "price": "Baidu",
                              "condition":"400",
                              "date": "2020.09.31"
                         },
                         {    
                              "id":"3",
                              "price": "SoSo",
                              "condition":"400",
                              "date": "2020.09.11"
                         },
                             {    
                              "id":"4",
                              "price": "SoSo",
                              "condition":"400",
                              "date": "2020.09.11"
                         },
                             {    
                              "id":"5",
                              "price": "SoSo",
                              "condition":"400",
                              "date": "2020.09.11"
                         },    {    
                              "id":"6",
                              "price": "SoSo",
                              "condition":"400",
                              "date": "2020.09.11"
                         }
                         ]
                    },
                    "boy":{ 
                         "company":"def",  
                         "brandFold":false,  
                         "detailList": [
                         {    
                              "id":"1",
                              "price": "Sina",
                              "condition":"400",
                              "date": "2020.09.20"
                         },
                         {    
                              "id":"2",
                              "price": "Baidu",
                              "condition":"400",
                              "date": "2020.09.01"
                         },
                         {    
                              "id":"3",
                              "price": "SoSo",
                              "condition":"400",
                              "date": "2020.09.11"
                         },
                          {    
                              "id":"4",
                              "price": "SoSo",
                              "condition":"400",
                              "date": "2020.09.11"
                         },
                          {    
                              "id":"5",
                              "price": "SoSo",
                              "condition":"400",
                              "date": "2020.09.11"
                         },
                          {    
                              "id":"6",
                              "price": "SoSo",
                              "condition":"400",
                              "date": "2020.09.11"
                         },
                          {    
                              "id":"7",
                              "price": "SoSo",
                              "condition":"400",
                              "date": "2020.09.11"
                         }
                         ]
                    }

               },
				// detailList:[
				// {price:"20",date:"2020-09-20"},
				// {price:"25",date:"2020-09-21"},
				// {price:"30",date:"2020-09-22"},
				// {price:"40",date:"2020-09-23"},
				// {price:"50",date:"2020-09-24"},
				// {price:"60",date:"2020-09-25"},
				// ]

			}
		}
		,
		methods: {
			handleClick(tab, event) {
				console.log(tab, event);
			},
			goBack() {
				console.log('go back');
			},
			changeFoldState(index) {
				//this.brandFold = !this.brandFold
				console.log(index)

				this.items[index].brandFold = this.items[index].brandFold?false:true;
			}
		},
		// 计算属性
		computed: {

			showdetailList: {
				get: function () {
					if (this.brandFold) {

						// 如果这个是折叠的，并且他的红包少于3条使用他本身
						if (this.detailList.length < 2) {
							return this.detailList
						}

						let newArr = []
						for (var i = 0; i < 2; i++) {
							let item = this.detailList[i]
							newArr.push(item)
						}
						return newArr
					}

					return this.detailList
				},
				set: function (val) {
					this.showdetailList = val
				}
			}
		}
	}
</script>


<style  scoped lang="less">
	*{
		margin: 0;
		line-height: 1.5;
	}
	.content{
		/*		padding: 15px;*/

	}	
	.el-tabs{
		/*background: #fff;*/

	}



	.el-tabs__header{
		background-color: #fff;
	}
	.wraper_list{
		border-radius: 15px;
		background-color: #fff;
		display: flex;
		flex-direction: column;
		height: auto;
		transition: all 1000ms linear 500ms;
		margin-bottom: 20px;
		.wraper_info{
			display: flex;
			flex-direction: row;
			align-items: center;
			margin:10px 10px 0;
			img{
				width: 35px;
				height: 35px;
			}
			h3{
				margin-left: 10px;
			}
		}
		.floldState{
			color: #bfbfbf;
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: center;
			.down{
				transform: rotate(0deg);
				transition: all 200ms linear 500ms;
			};
			.up{
				transform: rotate(180deg);
				transition: all 200ms linear 500ms;


			};
			img{
				width:20px;
				height: 20px;

			};
		}
		.card_list{
			background-color: #ffeaee;
			border-radius: 15px;
			padding: 15px;
			margin-left: 10px;
			margin-right: 10px;
			margin-top: 10px;
			margin-bottom: 10px;
			.card_item{
				color: #e43;
				display: flex;
				flex-direction: row;
				/*padding: 10px;*/
				align-items: center;
				justify-content: space-around;
				&_condition{
					text-align: left;
					h4{
						font-size: 14px;
						font-weight: bold;
					}
					p{
						font-size: 12px;
					}
					
				}
				&_use{
					align-self: flex-end;
					.redBtn{
						background: transparent;
						border:1px solid var(--theme-color);
						color: var(--theme-color)
					}

				}
				

			}
		}
	}

	.el-tab-pane{
		padding :0 15px;

	}
	.el-tabs__item{
		height: 60px!important;
		line-height: 60px!important;
		background-color: #fff;
	}




</style>







// WEBPACK FOOTER //
// src/page/hongbao.vue